export const takEntitiesKeys = {
  all: () => ['tak_entities'] as const,
  list: () => [...takEntitiesKeys.all(), 'list'] as const,
};
